const cardSlider = document.querySelectorAll('.card-gallery');
const defaultSliderOptions = {
    speed: 600,
    watchOverflow: true,
    observer: true,
    resizeObserver: true,
    slidesPerView: 1,
    loopPreventsSlide: false,
    preventInteractionOnTransition: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    navigation: {
        nextEl: '.card__slider-button--next',
        prevEl: '.card__slider-button--prev',
    },
};

const initSlider = (elem) => {
    if (!elem) return;

    const countsElements = elem.querySelectorAll('.card-gallery__slide').length;
    const sliderOptions = {...defaultSliderOptions};

    if (elem.hasAttribute('data-autoplay')) {
        sliderOptions.autoplay = {
            delay: 2200,
            disableOnInteraction: false,
        };
    }

    const swiper = new Swiper(elem, sliderOptions);
};

if (cardSlider.length > 0) {
    cardSlider.forEach((elem) => {
        initSlider(elem);
    });
}